// Small formatting helpers shared by the portal pages.

// Firestore Timestamp, {seconds}, unix seconds (Stripe), Date or string -> Date | null
export function toDate(ts) {
  if (ts == null || ts === "") return null;
  if (typeof ts === "number") return new Date(ts < 1e12 ? ts * 1000 : ts);
  if (ts.toDate) return ts.toDate();
  if (ts.seconds != null) return new Date(ts.seconds * 1000);
  const d = new Date(ts);
  return isNaN(d) ? null : d;
}

export function tsMs(ts) {
  const d = toDate(ts);
  return d ? d.getTime() : 0;
}

export function formatDate(ts, fallback = "—") {
  const d = toDate(ts);
  return d ? d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : fallback;
}

export function formatDateTime(ts, fallback = "—") {
  const d = toDate(ts);
  return d ? d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : fallback;
}

export function timeAgo(ts) {
  const d = toDate(ts);
  if (!d) return "";
  const mins = Math.floor((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  if (mins < 1440) return `${Math.floor(mins / 60)}h ago`;
  if (mins < 10080) return `${Math.floor(mins / 1440)}d ago`;
  return formatDate(d);
}

export function money(n, opts = {}) {
  return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD", ...opts }).format(Number(n || 0));
}

export const cents = (c) => money((Number(c) || 0) / 100);

export function initials(name = "", email = "") {
  // "Town of Westbrook" -> "WE", not "TO"
  const src = String(name || "").trim().replace(/^(town|city|village|borough|township) of\s+/i, "") || String(email || "").split("@")[0] || "?";
  const words = src.split(/[\s._-]+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return src.split(/[\s._-]+/).filter(Boolean).map((p) => p[0]).join("").slice(0, 2).toUpperCase();
}

export function cityName(c = {}) {
  return c.cityName || c.businessName || "Untitled city";
}

export function csvCell(v) {
  return `"${String(v == null ? "" : v).replace(/"/g, '""')}"`;
}

export function toCsv(rows) {
  return rows.map((r) => r.map(csvCell).join(",")).join("\n");
}

export function invoiceStatusTone(s) {
  return { paid: "green", open: "amber", uncollectible: "red", void: "outline", draft: "" }[s] || "";
}

export function subscriptionLabel(s) {
  return (
    {
      active: "Active",
      trialing: "Trial",
      past_due: "Past due",
      canceled: "Canceled",
      incomplete: "Waiting for first payment",
      unpaid: "Unpaid",
      not_started: "Not started",
    }[s] || "Not started"
  );
}

export function subscriptionTone(s) {
  return { active: "green", trialing: "amber", past_due: "red", unpaid: "red", canceled: "outline", incomplete: "amber" }[s] || "";
}